import { post } from "../api";

export const forgotPassword = async (email: string) => {
    const response = await post(`/auth/forgot-password?email=${encodeURIComponent(email)}`, {});
    return response.data;
};

export const resetPassword = async (token: string, newPassword: string) => {
    const response = await post(`/auth/reset-password?token=${token}&newPassword=${encodeURIComponent(newPassword)}`, {});
    return response.data;
};
